// extracted by mini-css-extract-plugin
export default {"list":"hfIQ4","item":"YBg7P","itemContent":"wb3Zq","itemIcon":"smKAp","itemLabel":"HTCic","addingText":"taQGu","arrow":"OQEme"};